<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Mobile menu toggle -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Spacer to push right side items right -->
    <div class="flex-grow-1" />

    <!-- Right side nav -->
    <b-navbar-nav class="nav align-items-center ml-auto">
      <search-bar />
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>

  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
import SearchBar from './components/SearchBar.vue'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    SearchBar,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
